export const TITLE_MATCHER: Record<string, string> = {
    Téléphones: 'Smartphones',
    'Bons Plans': 'en promotion',
    'Click & Collect': 'en Click & Collect',
    Apple: 'iPhone',
    'Smartphone pas cher': 'pas cher',
    'Meilleur rapport qualité-prix': 'au meilleur rapport qualité-prix',
    'Meilleur smartphone': ': notre top selection',
    'Smart Change': 'avec Smart Change',
    'Petits prix': 'à petits prix',
    Nouveautés: 'les plus récents',
    'Offres du moment': 'en promotion',
    'Carte SIM': 'avec carte SIM',
    eSIM: 'avec eSIM',
};

export const DESCRIPTION_MATCHER: Record<string, string> = {
    'Meilleur smartphone': 'de notre top selection',
};

export const BASE_KEYWORDS = 'Téléphone, téléphones, smartphone, smartphones, ';

export const NO_INDEX_SLUGS: string[] = [
    'tcl-kids-watch-mt48',
    'tcl-kids-watch-mt48-noir',
    'tcl-kids-watch-mt48-rose',
    'tcl-kids-watch-mt48-bleu',
];
